import { render, staticRenderFns } from "./AddJointScreen.vue?vue&type=template&id=a03a93a2&scoped=true&"
import script from "./AddJointScreen.vue?vue&type=script&lang=js&"
export * from "./AddJointScreen.vue?vue&type=script&lang=js&"
import style0 from "./AddJointScreen.vue?vue&type=style&index=0&id=a03a93a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03a93a2",
  null
  
)

export default component.exports